export const getUser = ({ app }) => app.user;
export const getToken = ({ app }) => app.token;
export const getIndustries = ({ app }) => app.industries;
export const getRegions = ({ app }) => app.regions;
export const getLensLayers = ({ app }) => app.lensLayers;
export const getLandplotsLayers = ({ app }) => app.landplotsLayers;
export const getReportLayers = ({ app }) => app.reportLayers;
export const getSites = ({ app }) => app.sites;
